// extracted by mini-css-extract-plugin
export default {"root":"ButtonSettings_root__CLePw"};